<template>
  <p v-if="text" class="txt-body-s-regular text-subtle" data-testid="notification-subheadline">
    {{ text }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { fieldValue } from './blockHelpers'
import type { NotificationBlock } from './types'

const props = defineProps<{
  block: NotificationBlock
}>()

const text = computed(() => fieldValue(props.block, 'text'))
</script>
